import {
  HOST_EVENT_COMPOSITION_SET,
  HOST_EVENT_COMPOSITION_REQ,
  HOST_EVENT_COMPOSITION_SUCCESS,
  HOST_EVENT_COMPOSITION_ERROR
} from './event_composition.type'
import ApiRest from '@/api/api-rest'

const state = {
  hostEventCompositionReqStatus: '',
  hostEventComposition: {}
}

const getters = {
  hostEventCompositionReqStatus: state => state.hostEventCompositionReqStatus,
  hostEventComposition: state => state.hostEventComposition
}

// Best Practice - updates state
const mutations = {
  [HOST_EVENT_COMPOSITION_SET]: (state, data) => {
    state.hostEventComposition = data
  },
  [HOST_EVENT_COMPOSITION_REQ]: state => {
    state.hostEventCompositionReqStatus = 'loading'
  },
  [HOST_EVENT_COMPOSITION_SUCCESS]: (state, data) => {
    state.hostEventCompositionReqStatus = 'saved'
  },
  [HOST_EVENT_COMPOSITION_ERROR]: (state, errMsg) => {
    state.hostEventCompositionReqStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [HOST_EVENT_COMPOSITION_REQ] (context, payload) {
    let eventCompositionUrl = '/bi/event/composition'
    if (!_.isEmpty(payload.agentId)) {
      eventCompositionUrl = `${eventCompositionUrl}/${payload.agentId}`
    }
    return new Promise((resolve, reject) => {
      context.commit(HOST_EVENT_COMPOSITION_REQ)
      ApiRest()
        .post(eventCompositionUrl, {
          date_range: payload.queryDate
        })
        .then(({ data }) => {
          context.commit(HOST_EVENT_COMPOSITION_SET, data)
          context.commit(HOST_EVENT_COMPOSITION_SUCCESS)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(HOST_EVENT_COMPOSITION_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [HOST_EVENT_COMPOSITION_SUCCESS] (context) {
    context.commit(HOST_EVENT_COMPOSITION_SUCCESS)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/event_composition/event_composition.module.js